module.exports = __webpack_public_path__ + "assets/img/portfolio-trecias.e83572a1.jpg";